import { render, staticRenderFns } from "./ModalIframe.vue?vue&type=template&id=9ea15ee6&scoped=true"
import script from "./ModalIframe.vue?vue&type=script&lang=js"
export * from "./ModalIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea15ee6",
  null
  
)

export default component.exports